// extracted by mini-css-extract-plugin
export default {"Customizado":"estilo_Customizado__mVFjB","ContainerGrid2Colunas":"estilo_ContainerGrid2Colunas__UzqsQ","Item_Pesquisa":"estilo_Item_Pesquisa__SaPQg"};